import { PropsWithChildren } from "react";
import { wrappers } from "shared/styles";
import React from "react";

export const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  return <section css={wrappers.page}>{children}</section>;
};
